import { c as _c } from "react/compiler-runtime";
import { palette } from '../../theme';
import { Box, ListItemButton, Typography } from '@mui/material';
import { useEffect, useRef } from 'react';
import type { SingleSelectOption } from './';
export const ListOptions = t0 => {
  const $ = _c(5);
  const {
    id,
    isOpen,
    activeIndex,
    handleSelectOption,
    options,
    selectedOption
  } = t0;
  const listOptionsRefs = useRef([]);
  const setItemListItemRef = listItemIndex => listItemRef => {
    listOptionsRefs.current[listItemIndex] = listItemRef;
  };
  let t1;
  if ($[0] !== activeIndex || $[1] !== isOpen) {
    t1 = [isOpen, activeIndex];
    $[0] = activeIndex;
    $[1] = isOpen;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useEffect(() => {
    if (isOpen) {
      listOptionsRefs.current[activeIndex]?.focus({
        preventScroll: true
      });
    }
  }, t1);
  const t3 = options.map((t2, idx) => {
    const {
      label: optionLabel,
      value,
      count
    } = t2;
    const selected = selectedOption === value;
    return <ListItemButton key={value} id={`${id}-option-${value}`} ref={setItemListItemRef(idx)} role="option" aria-selected={selected} tabIndex={idx === activeIndex ? 0 : -1} onClick={() => handleSelectOption(value)} sx={{
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      px: 3,
      py: 2,
      height: 36,
      width: "100%",
      bgcolor: selected ? "white" : "transparent",
      "&:hover": {
        bgcolor: "neutral.lightest"
      },
      "&:focus-visible": {
        outline: "2px solid #4B99E6",
        outlineOffset: "-2px"
      }
    }}><Box sx={{
        display: "flex",
        alignItems: "center",
        gap: 1
      }}><Typography sx={{
          color: "text.secondary",
          fontWeight: 400,
          fontSize: 14
        }}>{optionLabel}</Typography>{count !== undefined && <Typography sx={{
          color: "text.secondary",
          fontSize: 12
        }}>({count})</Typography>}</Box><Box sx={{
        width: 24,
        display: "flex",
        justifyContent: "flex-end"
      }}>{selected && <span className="mask-icon mask-icon-check" style={{
          width: "20px",
          height: "20px",
          backgroundColor: palette.greens.main
        }} />}</Box></ListItemButton>;
  });
  let t4;
  if ($[3] !== t3) {
    t4 = <>{t3}</>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};